import { __rest } from "tslib";
import React, { useState } from 'react';
import { useXflowPrefixCls } from '@antv/xflow-core';
import { DoubleRightOutlined, DoubleLeftOutlined } from '@ant-design/icons';
import { get } from 'lodash';
import { WorkspacePanel } from '../base-panel';
import { registerCustomNode } from './utils';
import { NodePanelBody } from './panel-body';
// import { NodePanelHeader } from '../canvas-node-tree-panel/panel-header'
import { NodePanelHeader } from './panel-header';
import { usePanelLyaoutStyle } from '../canvas-node-tree-panel/utils';
import { usePanelData } from './service';
import { CONTAINER_CLASS, PANEL_HEADER_HEIGHT } from './constants';
export { setGroupRender } from './group-panel';
export * from './constants';
export * from './utils';
export * from './interface';
export const NodePanelMain = props => {
    const { prefixClz, position = { width: 240, top: 0, bottom: 0, left: 0 }, showHeader = true } = props, rest = __rest(props, ["prefixClz", "position", "showHeader"]);
    const { width = 200 } = position;
    const { headerStyle, bodyStyle } = usePanelLyaoutStyle(props);
    const { state, onKeywordChange } = usePanelData(props);
    return (React.createElement(React.Fragment, null,
        showHeader && (React.createElement(WorkspacePanel, Object.assign({}, rest, { position: {
                top: 0,
                left: 0,
                height: PANEL_HEADER_HEIGHT,
                width,
            } }),
            React.createElement(NodePanelHeader, Object.assign({}, props, { state: state, style: headerStyle, onKeywordChange: onKeywordChange })))),
        React.createElement(WorkspacePanel, Object.assign({ className: `${CONTAINER_CLASS}-nodes` }, rest, { position: Object.assign(Object.assign({}, position), { top: showHeader ? PANEL_HEADER_HEIGHT : 0 }) }),
            React.createElement(NodePanelBody, Object.assign({}, props, { state: state, style: bodyStyle })))));
};
export const FlowchartNodePanel = props => {
    registerCustomNode(get(props, 'registerNode'));
    const prefixClz = useXflowPrefixCls('node-panel');
    const [collpased, setCollpased] = useState(false);
    const { show = true, position = { width: 240, top: 40, bottom: 0, left: 0 } } = props, rest = __rest(props, ["show", "position"]);
    if (!show) {
        return null;
    }
    const { width = 200, left } = position;
    return (React.createElement(WorkspacePanel, { className: CONTAINER_CLASS, position: Object.assign(Object.assign({}, position), { left: !collpased ? left : -width }) },
        React.createElement("div", { className: `${CONTAINER_CLASS}-wrapper` },
            React.createElement(WorkspacePanel, Object.assign({ className: prefixClz }, rest, { position: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                } }),
                React.createElement(NodePanelMain, Object.assign({}, props, { prefixClz: prefixClz, position: position }))),
            React.createElement("div", { className: `${CONTAINER_CLASS}-icon`, style: {
                    top: 21,
                    right: !collpased ? -10 : -20,
                    borderRadius: !collpased ? '50%' : '0 50% 50% 0',
                    borderLeft: !collpased ? '' : 'none',
                }, onClick: () => {
                    setCollpased(!collpased);
                } }, collpased ? React.createElement(DoubleRightOutlined, null) : React.createElement(DoubleLeftOutlined, null)))));
};
//# sourceMappingURL=index.js.map